import React, { FC } from 'react';

export const Divider: FC<React.PropsWithChildren<unknown>> = () => <div className="tw-w-full tw-h-px tw-bg-blue-gray-900 tw-opacity-10" />;
